
import { Options, Vue } from 'vue-class-component';
import { BagEstimationClient } from '@/services/Services';
import EditTotalWeightModal from '../footwear/modals/editTotalWeightModal.vue';
import EditCompositionPercentageModal from '../footwear/modals/editCompositionPercentageModal.vue';
import * as OM from '@/Model';
import * as VM from '@/viewModel';
import store from '@/store';
import InfoModal from '@/components/modals/infoModal.vue';

@Options({
    components: {
    }
})
export default class ComponentsWeights extends Vue {

    estimationIdentifier: string = "";

    bagData: OM.BagData = new OM.BagData();
    bagComposition: OM.SelectedComposition = new OM.SelectedComposition();
    errorMessage: string = "";

    loaded: boolean = false;
    hasCustomComposition: boolean = false;

    created() {
        this.estimationIdentifier = this.$route.params.estimationIdentifier.toString();
        this.init();
    }

    init() {
        Promise.all([
            BagEstimationClient.getEstimationBagData(this.estimationIdentifier),
            BagEstimationClient.hasCustomComposition(this.estimationIdentifier)
        ])
        .then(xs => {
            this.bagData = xs[0];
            this.hasCustomComposition = xs[1];
            this.getBagComposition(false, false);
        })
    }

    get isReadOnly() {
        return store.state.loggedUser.role == VM.Roles.ReadOnly;
    }

    get formattedData() {
        let dataWithIndent = this.bagComposition.percentageCompositionValues.map((item) => {
            let indentName = item.parentName ? `-- ${item.name}` : item.name;
                return {...item, indentName};
        });
        return dataWithIndent;
    }

    getBagComposition(getDefault: boolean, useEdmondPreset: boolean) {
        BagEstimationClient.getBagComposition(this.bagData.garment.identifier, this.estimationIdentifier, getDefault, useEdmondPreset)
        .then(x => {
            this.bagComposition = x;

            setTimeout(() => {
                this.loaded = true;
            }, 100);
        })
    }

    // Rebuilding the composition recreates every row, so the materials and countries
    // picked in the next step are lost. Say so before doing it.
    confirmReset(useEdmondPreset: boolean) {
        this.$opModal.show(InfoModal, {
            text: this.$localizationService.getLocalizedValue("Reset composition", "Reset composition"),
            subtitle: this.$localizationService.getLocalizedValue(
                "The composition will be rebuilt and the materials and countries already selected will be cleared.",
                "The composition will be rebuilt and the materials and countries already selected will be cleared."),
            confirm: this.$localizationService.getLocalizedValue("Confirm", "Confirm"),
            deny: this.$localizationService.getLocalizedValue("Cancel", "Cancel"),
            confirmCb: () => {
                this.$opModal.closeLast();
                this.getBagComposition(true, useEdmondPreset);
            },
            denyCb: () => {
                this.$opModal.closeLast();
            }
        })
    }

    openEditWeightModal() {
        this.$opModal.show(EditTotalWeightModal, {
            actualTotalWeight: this.bagComposition.totalWeight,
            saveCallback: (newWeight: number) => {
                BagEstimationClient.updateTotalWeight(this.estimationIdentifier, newWeight)
                .then(x => {
                    this.$opModal.closeLast();
                    this.init();
                })
            }
        })
    }

    openEditCompositionPercentageModal(name: string, percentage: number) {
        var realName = name.indexOf("--") == -1 ? name : name.substring(3);

        this.$opModal.show(EditCompositionPercentageModal, {
            name: realName,
            actualPercentage: percentage,
            saveCallback: (newPercentage: number) => {
                var model = new OM.FootwearEstimationUpdatePercentageCompositionValueVM();
                model.identifier = this.estimationIdentifier;
                model.name = realName;
                model.percentage = newPercentage;

                BagEstimationClient.updatePercentageCompositionValue(model)
                .then(x => {
                    this.$opModal.closeLast();
                    this.init();
                })
                .catch(y => {
                    this.$opModal.show(InfoModal, {
                        text: this.$localizationService.getLocalizedValue("Error", "Error"),
                        subtitle: this.$localizationService.getLocalizedValue("Percentage after calculation too High! Try with another value", "Percentage after calculation too High! Try with another value"),
                        deny: this.$localizationService.getLocalizedValue("Close", "Close"),
                        denyCb: () => {
                            this.$opModal.closeLast();
                        }
                    })
                })
            }
        })
    }
}
